const spaceRemover = (text: string) => {
  return text?.replace(/\s/g, '');
};

export default spaceRemover;
